(function () {
  'use strict';

  angular
    	.module('MktzapApp.Controllers')
    	.requires
    	.push(
      'ngTable'
    		, 'chart.js'
    	);

  angular.module('MktzapApp.Controllers')
    	.controller('ReportsMessageAccountingController', reports);

  reports.$inject = ['$scope', 'NotificationService', 'ReportsService', 'LangService'];

  function reports ($scope, NotificationService, ReportsService, LangService) {
    var vmRMessageAccounting = this;
    	$scope.vmRMessageAccounting = vmRMessageAccounting;

    vmRMessageAccounting.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY'),
      extraParams: {
        activePrice: 0.30,
        receptivePrice: 0.03
      }
    };

    LangService
      .getPageLabels({ 'page': 'menu.reports.messageAccounting' })
      .$promise
      .then(function (data) {
        vmRMessageAccounting.labels = data.lang;
      });

    vmRMessageAccounting.generate = function () {
      vmRMessageAccounting.clicked = true;
      vmRMessageAccounting.filters.sendByEmail = true;
      vmRMessageAccounting.filters.typeReport = 5;
      vmRMessageAccounting.filters.reportTitle = vmRMessageAccounting.labels.title;
      vmRMessageAccounting.filters.emailMessage = vmRMessageAccounting.labels.emailMessage;

      ReportsService
        .get({
          name: 'MessageAccounting',
          filters: vmRMessageAccounting.filters
        })
        .$promise
        .then(function (result) {
          vmRMessageAccounting.result = result;
        })
        .catch(function (error) {
          vmRMessageAccounting.clicked = false;
          NotificationService.errorHandler(error, vmRMessageAccounting.labels.requestError);
        });
    }
  }
})();
